<template>
  <div class="address">
    <el-button type="primary" class="add_address" @click="addAddress">添加新地址 Add a new address</el-button>
    <div class="address_list">
      <el-table :data="addressList" style="width: 100%" :header-cell-style="{ background: '#FCFCFC' }" border>
        <el-table-column prop="consigneeName" label="收货人 Consignee" align="center"> </el-table-column>
        <el-table-column prop="addressNotag" label="地址 Address" align="center"> </el-table-column>
        <el-table-column prop="linkMobile" label="手机号 Telephone" align="center"> </el-table-column>
        <el-table-column prop="adjustTypeNotag" label="操作 Operation" align="center">
          <template slot-scope="scope">
            <span class="color-text" @click="handleModdify(scope.row)">编辑 Editor</span>
            <span class="color-text" @click="handleDelete(scope.row.id)">删除 Delete</span>
          </template>
        </el-table-column>
        <el-table-column prop="isDefault" label="" align="center">
          <template slot-scope="scope">
            <span class="color_isDefault" @click="scope.row.isDefault == 1 ? '' : handleModdify(scope.row)">{{
              scope.row.isDefault == 1 ? "默认地址 Default" : "设为默认 Default"
            }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <AddressDialog
      v-if="addressVisible"
      :visible.sync="addressVisible"
      title="添加收货地址"
      :info="info"
      @dialogCallback="dialogCallback"
    ></AddressDialog>
    <TablePage ref="list" @page-change="getAddressList" :total="total" :pageSizeNum="5"> </TablePage>
  </div>
</template>

<script>
import AddressDialog from "./components/AddressDialog";
import TablePage from "@/components/base/TablePage";
export default {
  name: "order",
  components: { AddressDialog, TablePage },
  data() {
    return {
      addressList: [],
      info: {},
      addressVisible: false,
      total: 0,
    };
  },
  props: {},
  computed: {},
  async mounted() {
    this.searchHandler();
  },
  methods: {
    // 初始化查询
    searchHandler() {
      this.$refs.list.reset();
    },
    async dialogCallback(val) {
      let userInfo = JSON.parse(localStorage.getItem("webUserInfo"));
      const params = {
        address: val.address,
        cityName: val.cityName,
        consigneeName: val.consigneeName,
        isDefault: val.isDefault,
        linkMobile: val.linkMobile,
        provinceName: val.provinceName,
        regionName: val.regionName,
        uid: userInfo.uid,
        point: val.point,
      };
      try {
        if (val.id) {
          await this.$api.modifyDeliver({id: val.id, ...params});
        } else {
          await this.$api.getDeliverAdd(params);
        }
        this.addressVisible = false;
        this.searchHandler();
      } catch (error) {
        console.log(error);
      }
    },
    //编辑
    async handleModdify(row) {
      this.info = row;
      this.addressVisible = true;
    },
    //删除
    async handleDelete(id) {
      this.$confirm(`是否删除`, "提示", {
        type: "warning",
      })
        .then(async () => {
          await this.$api.getDeliverDelete({ id });
          this.$message.success("操作成功");
          this.searchHandler();
        })
        .catch(() => {});
    },
    addAddress() {
      this.info = {};
      this.addressVisible = true;
    },
    async getAddressList(page, pageSize) {
      const params = {
        page: page,
        pageSize: pageSize,
      };
      try {
        let {
          data: { list, total },
        } = await this.$api.getDeliverList(params);
        this.addressList = (list || []).map((item) => {
          item.addressNotag = item.provinceName + item.cityName + item.address;
          return item;
        });
        this.total = total;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.address {
  width: 100%;
  margin-top: 25px;
  .add_address {
    width: 232px;
    height: 40px;
    background: #333333;
    font-size: 14px;
    
    font-weight: 400;
    color: #ffffff;
  }
  .address_list {
    margin-top: 60px;
    width: 1080px;
    .color-text {
      width: 28px;
      font-weight: 400;
      cursor: pointer;
    }
    .color-text:after {
      content: "|";
      color: #ddd;
      padding: 0 8px;
    }
    .color-text:last-child:after {
      content: "";
      padding: 0;
    }
    .color_isDefault {
      width: 135px;
      height: 30px;
      background: #fcfcfc;
      border: 1px solid #333333;
      padding: 0 10px;
      cursor: pointer;
    }
  }
}
</style>
